import $ from 'jquery'

export function initialise() {
  $(document).on('change', '[data-auto-submit]', event => {
    if (event.target.nodeName === 'SELECT') {
      $(event.currentTarget).trigger('submit')
    }
  })
}
